import React from "react";
import Swiper from 'react-id-swiper';
import { actions,
         mIsoSupport,
         mIsoSupportOnVideo,
         mShutterSpeedSupport,
         mShutterSpeedSupportOnVideo,
         mShutterSpeedSupportOnShutterSpeedMode,
         mEvSupport,
         mWbSupport,
         mApertureSupport,
         mOptionSupport } from '../../exports';
import "./plugin.css";
import "./swiper.min.css";
import classNames from 'classnames';

let checkIndex = 0;
  
class ThetaSwiper extends React.Component {

  handleClick(name,item) {
  	
  	let setOptions = { 
  	  name: 'camera.setOptions',
  	  parameters: {}
  	};

    let originOptions = this.props.options;
    let _options = undefined;
    
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
    } else {
      _options = originOptions.video;
    }
	
    if (name === 'action') {
        _options.exposureProgram = item.val;
        _options.exposureProgramTitle = item.title;
        _options.exposureProgramIcon = item.icon;
        originOptions.exposureProgramOpen = false;
        
      switch(Number(_options.exposureProgram)) {
        case 2:
       	    setOptions.parameters.options = {
    	      exposureProgram: String(item.val)
    	    };
          break;
        case 4:
       	    setOptions.parameters.options = {
    	      exposureProgram: String(item.val),
            shutterSpeed: _options.shutter.shutterSpeed,
            exposureCompensation: _options.shutter.exposureCompensation,
            whiteBalance: _options.shutter.whiteBalance
    	    };
          break;
        case 9:
       	    setOptions.parameters.options = {
    	      exposureProgram: String(item.val),
            iso: _options.iso.iso,
            exposureCompensation: _options.iso.exposureCompensation,
            whiteBalance: _options.iso.whiteBalance
    	    };
          break;
        case 1:
       	    setOptions.parameters.options = {
    	      exposureProgram: String(item.val),
            iso: _options.manual.iso,
            shutterSpeed: _options.manual.shutterSpeed,
            whiteBalance: _options.manual.whiteBalance
    	    };
          break;
        default:
          return;
      }
    } else {
      let suboption = undefined;
      switch(Number(_options.exposureProgram)) {
        case 2:
          suboption = _options.auto;
          break;
        case 3:
          suboption = _options.aperture;
          break;
        case 4:
          suboption = _options.shutter;
          break;
        case 9:
          suboption = _options.iso;
          break;
        case 1:
          suboption = _options.manual;
          break;
        default:
          break;
      }
        
      switch(name) {
        case 'iso':
          suboption.iso = item;
          
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      iso: item
  	    };
          break;
        case 'isoOnVideo':
          suboption.iso = item;
          
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      iso: item
  	    };
          break;
        case 'shutterspeed':
          suboption.shutterSpeed = item.val;
          suboption.shutterSpeedText = item.text
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      shutterSpeed: item.val
  	    };
          break;
        case 'shutterspeedSMode':
          suboption.shutterSpeed = item.val;
          suboption.shutterSpeedText = item.text
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      shutterSpeed: item.val
  	    };
          break;
        case 'shutterspeedOnVideo':
          suboption.shutterSpeed = item.val;
          suboption.shutterSpeedText = item.text
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      shutterSpeed: item.val
  	    };
          break;
        case 'ev':
          suboption.exposureCompensation = item;
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      exposureCompensation: item
  	    };
          break;
        case 'aperture':
          suboption.aperture = item;
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      aperture: item
  	    };
          break;
        case 'wb':
          suboption.whiteBalance = item.val;
          suboption.whiteBalanceIcon = item.icon;
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      whiteBalance: item.val
  	    };
          break;
        case 'filter':
          suboption._filter = item.val;
          suboption._filterText = item.text;
     	    setOptions.parameters.options={
  	      exposureProgram: String(_options.exposureProgram),
  	      _filter: '"' + item.val + '"'
  	    };
          break;
        default:
          break;
      }
      
      switch(Number(_options.exposureProgram)) {
        case 2:
           _options.auto = suboption;
          break;
        case 4:
          _options.shutter = suboption;
          break;
        case 9:
          _options.iso = suboption;
          break;
        case 1:
          _options.manual = suboption;
          break;
        default:
          break;
      }

      
    }
    
    if (originOptions.captureMode === 'image') {
      originOptions.image = _options;
    } else {
      originOptions.video = _options;
    }

    originOptions.command = setOptions;
    this.setState({
      options: originOptions
    });
    this.props.updateState({
      options: originOptions
    });
  }
  
  getISOParams() {
    let item = undefined;
    const originOptions = this.props.options;

    let _options = undefined;
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
      switch(Number(_options.exposureProgram)) {
        case 1:
          item = _options.manual.iso;
          break;
        case 9:
          item = _options.iso.iso;
          break;
        default:
          item = mIsoSupport[0];
          break;
      }
  
      for (let i = 0;  i < mIsoSupport.length;  i++  ) {
        if (item === mIsoSupport[i]) {
          checkIndex = i;
          break;
        }
      }

    } else {
      _options = originOptions.video;
      switch(Number(_options.exposureProgram)) {
        case 1:
          item = _options.manual.iso;
          break;
        case 9:
          item = _options.iso.iso;
          break;
        default:
          item = mIsoSupport[0];
          break;
      }
      for (let i = 0;  i < mIsoSupportOnVideo.length;  i++  ) {
        if (item === mIsoSupportOnVideo[i]) {
          checkIndex = i;
          break;
        }
      }
    }


    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: checkIndex,
    };
  }
  
  getAVParams() {
    let item = undefined;
    const originOptions = this.props.options;
    let _options = undefined;
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
    } else {
      _options = originOptions.video;
    }
    
    switch(Number(_options.exposureProgram)) {
      case 3:
        item = _options.aperture.aperture;
        break;
      case 1:
        item = _options.manual.aperture;
        break;
      default:
        item = 2.1;
        break;
    }

    for (let i = 0;  i < mApertureSupport.length;  i++  ) {
      if (item === mApertureSupport[i]) {
        checkIndex = i;
        break;
      }
    }

    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: checkIndex,
    };
  }
  
  getEVParams() {
    let item = undefined;
    const originOptions = this.props.options;
    let _options = undefined;
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
    } else {
      _options = originOptions.video;
    }
    
    switch(Number(_options.exposureProgram)) {
      case 2:
        item = _options.auto.exposureCompensation;
        break;
      case 3:
        item = _options.aperture.exposureCompensation;
        break;
      case 4:
        item = _options.shutter.exposureCompensation;
        break;
      case 9:
        item = _options.iso.exposureCompensation;
        break;
      case 1:
        item = _options.manual.iso;
        break;
      default:
        item = 64;
        break;
    }

    for (let i = 0;  i < mEvSupport.length;  i++  ) {
      if (item === mEvSupport[i]) {
        checkIndex = i;
        break;
      }
    }

    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: checkIndex,
    };
  }
  
  getSPParams() {
    let item = undefined;

    let _options = undefined;
    const originOptions = this.props.options;
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
      switch(Number(_options.exposureProgram)) {
      case 1:
        item = _options.manual.shutterSpeed;
        for (let i = 0;  i < mShutterSpeedSupport.length;  i++  ) {
          if (item === mShutterSpeedSupport[i].val) {
            checkIndex = i;
            break;
          }
        }
        break;
      case 4:
        item = _options.shutter.shutterSpeed;
        for (let i = 0;  i < mShutterSpeedSupportOnShutterSpeedMode.length;  i++  ) {
          if (item === mShutterSpeedSupportOnShutterSpeedMode[i].val) {
            checkIndex = i;
            break;
          }
        }
        break;
      default:
        item = mShutterSpeedSupport[0].val;
        break;
      }
    } else {
      _options = originOptions.video;
      switch(Number(_options.exposureProgram)) {
      case 1:
        item = _options.manual.shutterSpeed;
        break;
      case 4:
        item = _options.shutter.shutterSpeed;
        break;
      default:
        item = mShutterSpeedSupport[0].val;
      }
      
      for (let i = 0;  i < mShutterSpeedSupportOnVideo.length;  i++  ) {
        if (item === mShutterSpeedSupportOnVideo[i].val) {
          checkIndex = i;
          break;
        }
      }
    }
    

    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: checkIndex,
    };
  }
  
  getWBParams() {
    let item = undefined;
    let _options = undefined;
    const originOptions = this.props.options;
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
    } else {
      _options = originOptions.video;
    }
    
    switch(Number(_options.exposureProgram)) {
      case 2:
        item = _options.auto.whiteBalance;
        break;
      case 3:
        item = _options.aperture.whiteBalance;
        break;
      case 4:
        item = _options.shutter.whiteBalance;
        break;
      case 9:
        item = _options.iso.whiteBalance;
        break;
      case 1:
        item = _options.manual.whiteBalance;
        break;
      default:
        item = mWbSupport[0].val;
        break;
    }

    for (let i = 0;  i < mWbSupport.length;  i++  ) {
      if (item === mWbSupport[i].val) {
        checkIndex = i;
        break;
      }
    }

    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: checkIndex,
    };
  }
  
  getFIParams() {
    let item = undefined;
    let _options = undefined;
    const originOptions = this.props.options;
    if (originOptions.captureMode === 'image') {
      _options = originOptions.image;
    } else {
      _options = originOptions.video;
    }
    
    switch(Number(_options.exposureProgram)) {
      case 2:
        item = _options.auto._filter;
        break;
      default:
        item = mOptionSupport[0].val;
        break;
    }

    for (let i = 0;  i < mOptionSupport.length;  i++  ) {
      if (item === mOptionSupport[i].val) {
        checkIndex = i;
        break;
      }
    }

    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      initialSlide: checkIndex,
      breakpoints: {
        // when window width is <= 320px
        320: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        // when window width is <= 480px
        480: {
          // slidesPerView: 5,
          slidesPerView: 4,
          spaceBetween: 20
        },
        // when window width is <= 640px
        640: {
          slidesPerView: 10,
          spaceBetween: 30
        }
      }
    };
  }
  
  isChecked(index) {
    let checked = false;
    if (index === checkIndex) {
      checked = true;
    }
    return checked;
  }

  render() {
    const { select } = this.props;
    if (select === 'iso') {
        return (
          <Swiper {...this.getISOParams()}>
            { mIsoSupport.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='iso' type='radio' className={classNames('btn--data__value')} value={`${item}`} id={`iso${i}`} onClick={() => {this.handleClick('iso',item)}} checked={this.isChecked(i)}/>
        		<i for={`iso${i}`}  class="btn--data__key"  >{`${item}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'isoOnVideo') {
        return (
          <Swiper {...this.getISOParams()}>
            { mIsoSupportOnVideo.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='iso' type='radio' className={classNames('btn--data__value')} value={`${item}`} id={`iso${i}`} onClick={() => {this.handleClick('iso',item)}} checked={this.isChecked(i)}/>
        		<i for={`iso${i}`}  class="btn--data__key"  >{`${item}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'shutterspeed') {
        return (
          <Swiper {...this.getSPParams()}>
            { mShutterSpeedSupport.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='shutterspeed' type='radio'  className={classNames('btn--data__value')} value={`${item.val}`} id={`shutter${i}`} onClick={() => {this.handleClick('shutterspeed',item)}} checked={this.isChecked(i)} />
        		<i for={`shutter${i}`}>{`${item.text}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'shutterspeedSMode') {
        return (
          <Swiper {...this.getSPParams()}>
            { mShutterSpeedSupportOnShutterSpeedMode.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='shutterspeed' type='radio'  className={classNames('btn--data__value')} value={`${item.val}`} id={`shutter${i}`} onClick={() => this.handleClick('shutterspeed',item)} checked={this.isChecked(i)}/>
        		<i for={`shutter${i}`}>{`${item.text}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'shutterspeedOnVideo') {
        return (
          <Swiper {...this.getSPParams()}>
            { mShutterSpeedSupportOnVideo.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='shutterspeed' type='radio'  className={classNames('btn--data__value')} value={`${item.val}`} id={`shutter${i}`} onClick={() => this.handleClick('shutterspeed',item)} checked={this.isChecked(i)}/>
        		<i for={`shutter${i}`}>{`${item.text}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'ev') {
        return (
          <Swiper {...this.getEVParams()}>
            { mEvSupport.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='ev' type='radio'  className={classNames('btn--data__value')} value={`${item}`} id={`ev${i}`} onClick={() => {this.handleClick('ev',item)}} checked={this.isChecked(i)}/>
        		<i for={`ev${i}`}>{`${item}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'aperture') {
        return (
          <Swiper {...this.getAVParams()}>
            { mApertureSupport.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='apeture' type='radio'  className={classNames('btn--data__value')} value={`${item}`} id={`apeture${i}`} onClick={() => {this.handleClick('aperture',item)}} checked={this.isChecked(i)}/>
        		<i for={`apeture${i}`}>F{`${item}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'wb') {
        return (
          <Swiper {...this.getWBParams()}>
            { mWbSupport.map((item,i) => (
            <label className={classNames('scroll_btn','wb', 'swiper-slide')}>
        		<input name='wb' type='radio' value={`${item.val}`} id={`wb${i}`} onClick={() => {this.handleClick('wb',item)}} checked={this.isChecked(i)}/>
        		<i for={`wb${i}`} class={`btn ${item.icon}`} >{`${item.text}`}</i>
        		</label>
            ))}
          </Swiper>
    );
    } else if (select === 'filter') {
        return (
          <Swiper {...this.getFIParams()}>
            { mOptionSupport.map((item,i) => (
            <label className={classNames('scroll_btn','swiper-slide')}>
        		<input name='filter' type='radio' className={classNames('btn--data__value')} value={`${item.val}`} id={`option${i}`} onClick={() => {this.handleClick('filter',item)}} checked={this.isChecked(i)}/>
        		<i for={`option${i}`}>{`${item.text}`}</i>
        		</label>		
            ))}
          </Swiper>
        );
    } else if (select === 'actions') {
        return (
    	  <ul id="action_sheet__btn_list">
            { actions.map((item,i) => (
        		<li>
        		<input name='action' type='radio' className={classNames('btn--data__value')} value={`${item.val}`} id={`action${i}`} onClick={() => {this.handleClick('action',item)}}/>
        		<label for={`action${i}`} class="action">{`${item.title}`}</label>
        		</li>		
            ))}
          </ul>
        );
    } else {
        return (
          <div/>
        );
    }
  }
}

export default ThetaSwiper;



// WEBPACK FOOTER //
// ./src/components/shooting/ThetaSwiper.js